<template>
  <div class="page landing">
    <div class="banner">
      <img class="banner-img" :src="bannerImg" alt="" srcset="">
      <div class="download-btn" @click="download">
        {{ v2 ? '月卡低至38元，立享福利' : '月卡低至30元，立享福利'}}
      </div>
    </div>
    <!-- 特色 -->
    <div class="property">
      <div class="property-item">
        <div class="item-icon">
          <img src="https://static.ndmicro.com/tmd/landing/vip/images/icon01@2x.png" alt="">
        </div>
        <div class="item-content">
          <p class="p1">快速审批</p>
          <p class="p2">最快5分钟放款</p>
        </div>
      </div>
      <div class="property-item">
        <div class="item-icon">
          <img src="https://static.ndmicro.com/tmd/landing/vip/images/icon_02@2x.png" alt="">
        </div>
        <div class="item-content">
          <p class="p1">分期偿还</p>
          <p class="p2">可分12期偿还</p>
        </div>
      </div>
      <div class="property-item">
        <div class="item-icon">
          <img src="https://static.ndmicro.com/tmd/landing/vip/images/icon_03@2x.png" alt="">
        </div>
        <div class="item-content">
          <p class="p1">放心使用</p>
          <p class="p2">正规持牌机构</p>
        </div>
      </div>
    </div>
    <!-- 公司信息 -->
    <section class="company">
      <div class="company-item">
        <p>贷款额度，放款时间，还款方式，还款期限等以实际审批结果为准(综合年化利率区间15.4%-24%，单利计算)</p>
        <p>贷款有风险，请根据个人能力合理贷款，理性消费，避免逾期</p>
      </div>
      <div class="company-item">
        <p>重庆市崇天小额贷款有限公司</p>
        <p>公司地址：重庆市南岸区南滨路22号1栋长江国际大厦33层3319室</p>
        <p>渝公网安备 50010802002638号I渝ICP备18009772号-1</p>
      </div>
    </section>
    <ios-download v-model="downloadVisible"></ios-download>
  </div>
</template>

<script>
export default {
  name: 'landingVip',
  data () {
    const v2 = this.$route.query.version === 'v2'
    return {
      v2,
      bannerImg: v2 ? 'https://static.ndmicro.com/tmd/landing/vip/images/img_02@2x.png' : 'https://static.ndmicro.com/tmd/landing/vip/images/img_01@2x.png'
    }
  },
  mounted () {
    this.$emit('ready')
  },
  methods: {
    download () {
      this.downloadApp()
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.page.landing{
  .banner{
    width: 750px;
    height: 1170px;
    margin: 0 auto;
    background-size: cover;
    position: relative;
    .banner-img{
      width: 100%;
      height: 100%;
    }
    .download-btn{
      width: 560px;
      height: 154px;
      background: url('https://static.ndmicro.com/tmd/landing/vip/images/btn_jiekuan@2x.png') center no-repeat;
      background-size: cover;
      color: #fff;
      font-size: 36px;
      text-align: center;
      line-height: 154px;
      font-weight: bold;
      bottom: 52px;
      left: 50%;
      position: absolute;
      transform: translateX(-50%);
      animation: rotate 1.5s linear infinite;
    }
    @keyframes rotate {
      0% {
          transform:translateX(-50%) scale(1);
      }
      50% {
          transform:translateX(-50%) scale(0.9);
      }
      100% {
          transform:translateX(-50%) scale(1);
      }
  }
  }
  .property {
    display: flex;
    margin: 0 auto;
    padding-bottom: 75px;
    background-color: #FEF3DF;
    padding-top: 20px;
    .property-item {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      .item-icon {
        width: 60px;
        height: 60px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .item-content {
        .p1 {
          margin-top:18px;
          height: 40px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #763E12;
          line-height: 40px;
        }
        .p2 {
          height: 30px;
          font-size: 22px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #763E12;
          line-height: 30px;
        }
      }
    }
  }
  .company {
    width: 750px;
    height: 240px;
    font-size: 20px;
    line-height: 28px;
    background-color: #E5C4A0;
    color: #FFFFFF;
    padding: 24px 30px;
    .company-item{
      & + .company-item{
        margin-top: 24px;
      }
    }
  }
}
</style>